/**
 * Normalise une chaîne pour la recherche :
 * - Retire les accents (diacritiques)
 * - Convertit en minuscules
 * - Remplace les tirets et points par des espaces pour faciliter le découpage
 */
export function normalizeString(str: string | null | undefined): string {
    if (!str) return "";
    return str
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Retire les accents
        .replace(/[-.]/g, " ") // Remplace tirets et points par des espaces
        .trim();
}

/**
 * Vérifie si une chaîne cible correspond à un terme de recherche.
 * Gère le multi-mots : la cible doit contenir TOUS les mots du terme de recherche.
 */
export function fuzzyMatch(target: string, query: string): boolean {
    const normalizedTarget = normalizeString(target);
    const normalizedQuery = normalizeString(query);

    if (!normalizedQuery) return true;
    if (!normalizedTarget) return false;

    // Découpe le terme de recherche en mots
    const queryParts = normalizedQuery.split(/\s+/).filter(Boolean);

    // Vérifie que chaque mot est présent dans la cible
    return queryParts.every(part => normalizedTarget.includes(part));
}
